import React from 'react'
import ReactModal from 'react-modal'
import InteractiveFormPreview from './InteractiveFormPreview'
import { PrefillPreviewEntry, resolveShareableLinkForPreview } from './prefillPreviewUtils'

interface Props {
  isOpen: boolean
  onClose: () => void
  formData: any
  cardStyle?: string
  cardBackground?: string
  prefillData?: PrefillPreviewEntry[]
  recipientEmail: string
  recipientName?: string | null
  shareableLink?: string
}

const modalStyles: ReactModal.Styles = {
  overlay: { zIndex: 1050, backgroundColor: 'rgba(0,0,0,0.55)' },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: 'min(900px, 95vw)',
    height: 'min(90vh, 900px)',
    padding: 0,
    border: 'none',
    borderRadius: '12px',
    overflow: 'hidden'
  }
}

const PrefillFormPreviewModal: React.FC<Props> = ({
  isOpen,
  onClose,
  formData,
  cardStyle = '',
  cardBackground = '',
  prefillData = [],
  recipientEmail,
  recipientName,
  shareableLink
}) => {
  const liveLink = shareableLink ? resolveShareableLinkForPreview(shareableLink) : undefined

  return (
    <ReactModal isOpen={isOpen} onRequestClose={onClose} ariaHideApp={false} style={modalStyles}>
      <div className='d-flex flex-column h-100'>
        <div className='d-flex align-items-center justify-content-between px-4 py-3 border-bottom bg-light flex-shrink-0'>
          <div>
            <h5 className='mb-0 fw-bold'>Form Preview</h5>
            <small className='text-muted'>
              {recipientName ? `${recipientName} · ` : ''}
              {recipientEmail}
            </small>
          </div>
          <div className='d-flex gap-2 align-items-center'>
            {liveLink && (
              <a
                href={liveLink}
                target='_blank'
                rel='noreferrer'
                className='btn btn-sm btn-outline-primary'
              >
                Open live form
              </a>
            )}
            <button type='button' className='btn-close' onClick={onClose} />
          </div>
        </div>
        <div className='flex-grow-1 overflow-auto' style={{ minHeight: 0 }}>
          <InteractiveFormPreview
            formData={formData}
            cardBackground={cardBackground}
            cardStyle={cardStyle}
            prefillEntries={prefillData}
            isPrefillForm
          />
          <p className='interactive-form-preview__preview-note mb-0 px-3 pb-3'>
            Preview mode — submissions are not saved.
          </p>
        </div>
      </div>
    </ReactModal>
  )
}

export default PrefillFormPreviewModal
